import React from 'react';

export const DiscoverLogo = () => {
  return (
    <svg
      width="28"
      height="20"
      viewBox="0 0 28 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <g clipPath="url(#clip1)">
          <path
            d="M0.176392 0.696594L0.191401 16.4936H26.9982V0.696594H0.176392Z"
            fill="white"
          />
          <path
            d="M26.9531 9.49895C26.9531 9.49895 19.645 14.302 6.24011 16.4518H26.9531V9.49895Z"
            fill="#EF7622"
          />
          <path
            d="M26.9532 0.738301V16.4519H0.236398V0.738301H26.9532ZM27.1033 0.599243H0.0863037V16.5909H27.1033V0.599243Z"
            fill="black"
          />
          <path
            d="M2.44273 5.49409H1.33203V9.1096H2.44273C3.0281 9.1096 3.46337 8.98445 3.83861 8.69243C4.05867 8.52243 4.23586 8.30984 4.35774 8.0696C4.47961 7.82936 4.54321 7.5673 4.54405 7.30185C4.54405 6.2311 3.68851 5.49409 2.44273 5.49409ZM3.34329 8.20572C3.10314 8.4004 2.78795 8.49775 2.29263 8.49775H2.0825V6.10595H2.29263C2.78795 6.10595 3.08813 6.18938 3.34329 6.39797C3.47787 6.51288 3.58484 6.65275 3.65725 6.80847C3.72965 6.9642 3.76588 7.1323 3.76356 7.30185C3.76404 7.47114 3.72699 7.63872 3.6547 7.7942C3.58241 7.94968 3.47641 8.08975 3.34329 8.20572Z"
            fill="black"
          />
          <path
            d="M5.66978 5.49409H4.9043V9.1096H5.66978V5.49409Z"
            fill="black"
          />
          <path
            d="M7.53107 6.88464C7.08079 6.73168 6.94571 6.62043 6.94571 6.42575C6.94571 6.20326 7.18586 6.02248 7.51606 6.02248C7.63596 6.02409 7.75384 6.05127 7.86056 6.10192C7.96729 6.15256 8.05998 6.22531 8.13145 6.31451L8.5367 5.8278C8.21818 5.56616 7.80667 5.42257 7.38098 5.42453C6.69054 5.42453 6.16522 5.86952 6.16522 6.46747C6.16522 6.96808 6.40537 7.21838 7.12582 7.45478C7.30778 7.50845 7.48371 7.5783 7.65115 7.66337C7.72012 7.70297 7.77701 7.75826 7.81641 7.82397C7.85582 7.88969 7.87643 7.96365 7.87629 8.03882C7.87555 8.10857 7.85968 8.17746 7.82963 8.2414C7.79957 8.30534 7.75593 8.36303 7.70132 8.41104C7.64671 8.45904 7.58223 8.49637 7.51173 8.52082C7.44122 8.54527 7.36613 8.55633 7.29092 8.55334C7.11677 8.55707 6.94534 8.51281 6.79837 8.42616C6.6514 8.33951 6.53551 8.21438 6.4654 8.06664L5.97009 8.51162C6.31531 8.98442 6.75058 9.20691 7.32094 9.20691C8.11644 9.20691 8.67179 8.72021 8.67179 8.02492C8.65678 7.44088 8.38661 7.17666 7.53107 6.88464Z"
            fill="black"
          />
          <path
            d="M8.89677 7.30182C8.89495 7.55182 8.947 7.79964 9.04988 8.03077C9.15276 8.26189 9.3044 8.47166 9.49591 8.6478C9.68742 8.82393 9.91495 8.96288 10.1652 9.0565C10.4154 9.15012 10.6832 9.19653 10.9531 9.193C11.2866 9.19552 11.616 9.124 11.9137 8.98442V8.15007C11.8002 8.27204 11.6596 8.36994 11.5016 8.43712C11.3437 8.50431 11.1719 8.5392 10.9981 8.53943C10.2326 8.53943 9.69227 8.02492 9.69227 7.28791C9.68605 7.1285 9.71435 6.96956 9.77551 6.82045C9.83667 6.67134 9.92944 6.53509 10.0484 6.41974C10.1673 6.30438 10.3099 6.21226 10.4679 6.14881C10.6258 6.08536 10.7959 6.05186 10.9681 6.0503C11.3283 6.0503 11.6135 6.17545 11.9287 6.45356V5.61922C11.638 5.47428 11.3132 5.39786 10.9831 5.39672C10.4341 5.39413 9.90635 5.59312 9.51535 5.95016C9.12434 6.3072 8.90193 6.79321 8.89677 7.30182Z"
            fill="black"
          />
          <path
            d="M17.9626 7.92761L16.9119 5.49409H16.0864L17.7375 9.20694H18.1577L19.8388 5.49409H19.0133L17.9626 7.92761Z"
            fill="black"
          />
          <path
            d="M20.1838 9.1096H22.3452V8.49775H20.9493V7.52434H22.3002V6.91249H20.9493V6.10595H22.3452V5.49409H20.1838V9.1096Z"
            fill="black"
          />
          <path
            d="M25.3622 6.56484C25.3622 5.88346 24.8518 5.49409 23.9813 5.49409H22.8556V9.1096H23.6211V7.6634H23.7261L24.7768 9.12351H25.7074L24.4766 7.59387C25.047 7.48262 25.3622 7.12107 25.3622 6.56484ZM23.8312 7.16279H23.6061V6.06423H23.8462C24.3265 6.06423 24.5817 6.24501 24.5817 6.60656C24.5817 6.96811 24.3265 7.16279 23.8312 7.16279Z"
            fill="black"
          />
          <path
            d="M16.3114 7.30184C16.3114 7.68139 16.1899 8.05241 15.9624 8.36799C15.7348 8.68356 15.4113 8.92953 15.0328 9.07477C14.6543 9.22002 14.2378 9.25802 13.836 9.18397C13.4342 9.10993 13.0652 8.92716 12.7755 8.65878C12.4858 8.39041 12.2885 8.04847 12.2086 7.67622C12.1287 7.30397 12.1697 6.91813 12.3265 6.56747C12.4833 6.21682 12.7487 5.91712 13.0894 5.70625C13.43 5.49539 13.8305 5.38284 14.2401 5.38284C14.7891 5.38395 15.3153 5.58648 15.7034 5.94612C16.0916 6.30577 16.3102 6.79323 16.3114 7.30184Z"
            fill="#EF7622"
          />
          <path
            d="M25.7674 5.56362C25.7674 5.49409 25.7223 5.46628 25.6323 5.46628H25.5272V5.78611H25.6023V5.66096L25.6923 5.78611H25.7974L25.6773 5.66096C25.6902 5.66027 25.7028 5.65717 25.7144 5.65185C25.726 5.64654 25.7363 5.63912 25.7447 5.63003C25.7531 5.62094 25.7594 5.61038 25.7633 5.59897C25.7672 5.58756 25.7686 5.57553 25.7674 5.56362ZM25.6323 5.60534L25.6173 5.5219H25.6323C25.6773 5.5219 25.6923 5.53581 25.6923 5.56362C25.6923 5.59143 25.6623 5.60534 25.6323 5.60534Z"
            fill="black"
          />
          <path
            d="M25.6624 5.34113C25.603 5.34113 25.545 5.35744 25.4956 5.388C25.4462 5.41856 25.4078 5.46199 25.385 5.51281C25.3623 5.56363 25.3564 5.61955 25.368 5.6735C25.3795 5.72745 25.4081 5.777 25.4501 5.8159C25.4921 5.85479 25.5456 5.88128 25.6038 5.89201C25.662 5.90275 25.7224 5.89724 25.7772 5.87619C25.8321 5.85514 25.879 5.81949 25.912 5.77375C25.945 5.72802 25.9626 5.67425 25.9626 5.61924C25.9626 5.54548 25.9309 5.47474 25.8746 5.42258C25.8183 5.37043 25.742 5.34113 25.6624 5.34113ZM25.6624 5.85564C25.6149 5.85564 25.5684 5.84259 25.529 5.81814C25.4895 5.7937 25.4587 5.75895 25.4405 5.71829C25.4223 5.67764 25.4176 5.6329 25.4268 5.58974C25.4361 5.54658 25.459 5.50694 25.4926 5.47582C25.5261 5.44471 25.5689 5.42352 25.6155 5.41493C25.6621 5.40635 25.7104 5.41075 25.7543 5.42759C25.7982 5.44443 25.8357 5.47295 25.862 5.50954C25.8884 5.54613 25.9025 5.58914 25.9025 5.63315C25.8983 5.69087 25.8717 5.74522 25.8275 5.78613C25.7833 5.82704 25.7247 5.85174 25.6624 5.85564Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="27.1858"
            height="15.9917"
            fill="white"
            transform="translate(0 0.599243)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="27.017"
            height="15.9917"
            fill="white"
            transform="translate(0.0863037 0.599243)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
